module.exports = __webpack_public_path__ + "static/img/game-level-bg.379a03bd.png";